import { render, staticRenderFns } from "./OtherFilter.vue?vue&type=template&id=521cd3be&scoped=true&"
import script from "./OtherFilter.vue?vue&type=script&lang=js&"
export * from "./OtherFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521cd3be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardText,VCardTitle,VCheckbox,VRangeSlider,VSelect,VTextField})
